import React from "react";
import SelectInput from "../select/SelectInput";

const DomainDropdown = ({
    options,
    value,
    onChange,
}) => {
    return (
        <SelectInput
            options={options}
            value={options.find(x => x.value === value) || null}
            placeholder="Domain"
            onChange={onChange}
        />
    );
};

export default DomainDropdown;